var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2064 15H14.3329C15.52 15 16.6458 15.5273 17.4058 16.4393L18.4728 17.7196C19.5583 19.0223 18.632 21 16.9363 21H3.47648C1.7808 21 0.854491 19.0223 1.94004 17.7196L3.00701 16.4393C3.76699 15.5273 4.89278 15 6.0799 15H7.2064M10.2061 18V9M10.2061 9V3C10.2061 1.89543 11.1015 1 12.2061 1H17.588C18.3314 1 18.8149 1.78231 18.4824 2.44721L17.4297 4.55279C17.2889 4.83431 17.2889 5.16569 17.4297 5.44721L18.4824 7.55279C18.8149 8.21769 18.3314 9 17.588 9H10.2061Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.919ec4128d56881eb1bb2d604f0d66fb.svg";
export { ForwardRef as ReactComponent };